import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

// eslint-disable-next-line import/no-default-export
export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/ManageGradProgramPageContainerLoadable" */
      './ManageGradProgramPageContainer'
    ),
  loading: LoadableLoadingSection,
});
